import React, { useEffect, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import Skeleton from 'react-loading-skeleton';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { fetchCampaignPermalinksThunk } from 'slices/campaigns/permalinks/thunk';
import { AppDispatch, RootState } from 'store';
import { formatNumber, generateUniqueKey } from 'utils/helpers';
import IGLogoPNG from "../../../assets/images/brands/ig-logo.png"
const CampaignLinksStatus = () => {

    const dispatch: AppDispatch = useDispatch();
    const navigate = useNavigate();
    const { campaignId } = useParams();
    const { filters } = useSelector((state: RootState) => state.campaignPermalinks);
    const [filterId, setFilterId] = useState(generateUniqueKey(filters, ['page']));
    const [autoFetchReq, setAutoFetchReq] = useState(false);


    const campaignPermalinksData = useSelector((state: RootState) => state.campaignPermalinks.campaigns[campaignId!]?.filtered_lists?.[filterId!]);
    const campaignPermalinks = campaignPermalinksData?.list ?? [];
    const page = campaignPermalinksData?.page ?? 1;
    const has_more = campaignPermalinksData?.has_more ?? true;

    const loading = useSelector((state: RootState) => state.campaignPermalinks.loading);
    const error = useSelector((state: RootState) => state.campaignPermalinks.error);

    const statusCounts = useSelector((state: RootState) => state.campaignPermalinks.status_counts);

    const [pendingLinksCount, setPendingLinksCount] = useState(0);

    const [initialLoading, setInitialLoading] = useState(true);

    useEffect(() => {
        if (statusCounts.length > 0) {
            const pending = statusCounts.filter((data) => data.status === 'pending');
            setPendingLinksCount(pending.length);
        }
    }, [statusCounts])

    useEffect(() => {
        if (campaignId) {
            setInitialLoading(true);
            dispatch(fetchCampaignPermalinksThunk({ filters, campaignId }))
                .finally(() => {
                    setFilterId(generateUniqueKey(filters, ['page']));
                    setInitialLoading(false);
                })
        }
    }, [campaignId, filters])

    const nextPage = () => {
        if (has_more && campaignId) {
            const nextPageNumber = page + 1;
            dispatch(fetchCampaignPermalinksThunk({ filters: { ...filters, page: nextPageNumber }, campaignId }))
        }
    }

    useEffect(() => {
        const interval = setInterval(() => {
            if (campaignId && pendingLinksCount && filters) {
                setAutoFetchReq(true);
                dispatch(fetchCampaignPermalinksThunk({ filters, campaignId }))
                    .finally(() => {
                        setFilterId(generateUniqueKey(filters, ['page']));
                        setAutoFetchReq(false);
                    })
            }
        }, (1000 * 60 * 1))

        return () => {
            clearInterval(interval);
        }
    }, [pendingLinksCount, campaignId, filters])

    return (
        <div className="card campaign-insights-card">
            <div className="card-body p-0 m-0">
                <InfiniteScroll
                    dataLength={campaignPermalinks.length}
                    next={nextPage}
                    hasMore={has_more}
                    loader={<></>}
                    className="w-100"
                >
                    <table>
                        <thead>
                            <tr>
                                <th>Post</th>
                                <th className='text-start ps-4'>Likes</th>
                                <th className='text-start ps-4'>Comments</th>
                                <th className='text-start ps-4'>Views</th>
                                <th className='text-start ps-4'>Amount</th>
                                <th className='text-start ps-4'>Created At</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                !initialLoading && campaignPermalinks.map((campaignPermalink, i) => {
                                    return (
                                        <tr className="border-bottom-1 px-3" key={i}>

                                            {
                                                campaignPermalink.ig_post ? (
                                                    <React.Fragment>
                                                        <td>
                                                            <div className="py-3">
                                                                <div className="d-flex justify-content-start align-items-center gap-3 border-right-dashed td-content">
                                                                    <a href={campaignPermalink.permalink} target='_blank' rel='noreferrer'><div className='bgc-content bg-image cursor-pointer' style={{backgroundImage: `url(${campaignPermalink.ig_post.thumbnail_url})`, height: '60px', width: '40px', borderRadius: '4px'}}></div></a>
                                                                    <div className="d-flex flex-column justify-content-center">
                                                                        <div className="d-flex align-items-center gap-1">
                                                                            <img src={IGLogoPNG} alt="IG Logo" className='linked-posts-ig-logo' />
                                                                            <span className='linked-posts-ig-username'>{campaignPermalink.ig_post.ig_account.username}</span>
                                                                        </div>
                                                                        <span className='linked-post-posted-on'>{campaignPermalink.ig_post.posted_on}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className='ps-4'>
                                                            <div className="py-3">
                                                                <div className="d-flex justify-content-start align-items-center gap-1 border-right-dashed td-content">
                                                                    <span className=""> <i className='ri-heart-line me-1'></i> {formatNumber(Number(campaignPermalink.ig_post?.like_count ?? 0))}</span>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className='ps-4'>
                                                            <div className="py-3">
                                                                <div className="d-flex justify-content-start align-items-center gap-1 border-right-dashed td-content">
                                                                    <span className=""> <i className='ri-chat-3-line me-1'></i> {formatNumber(Number(campaignPermalink.ig_post?.comments_count ?? 0))}</span>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className='ps-4'>
                                                            <div className="py-3">
                                                                <div className="d-flex justify-content-start align-items-center gap-1 border-right-dashed td-content">
                                                                    <span className="">  <i className='ri-eye-line me-1'></i>  {formatNumber(Number(campaignPermalink.ig_post?.views_count ?? 0))}</span>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </React.Fragment>
                                                ) : (
                                                    <React.Fragment>
                                                        <td>
                                                            <div className="py-3">
                                                                <div className="d-flex justify-content-start align-items-center gap-1 border-right-dashed td-content">
                                                                    <a href={campaignPermalink.permalink} target='_blank' rel='noreferrer' className="">{campaignPermalink.permalink}</a>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td colSpan={3}>
                                                            <div className="py-3">
                                                                <div className="d-flex justify-content-center align-items-center gap-1 border-right-dashed td-content">
                                                                        {
                                                                            campaignPermalink.status === 'pending' ? (
                                                                                <span className="text-warning"> <i className='bx bx-time-five me-1'></i> In Progress</span>
                                                                            ) : (
                                                                                <span className="text-danger"> <i className='bx bx-error-circle me-1'></i> Failed</span>
                                                                            )
                                                                        }
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </React.Fragment>
                                                )
                                            }

                                            <td className='ps-4'>
                                                <div className="py-3">
                                                    <div className="d-flex justify-content-start align-items-center gap-1 border-right-dashed td-content">
                                                        <span className=""> <i className='bx bx-rupee me-1'></i> {formatNumber(Number(campaignPermalink.earning ?? 0))}</span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td className='ps-4'>
                                                <div className="py-3">
                                                    <div className="d-flex justify-content-start align-items-center gap-1 td-content">
                                                        <span className=""> <i className=' ri-calendar-line me-1'></i> {campaignPermalink.created}</span>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                            {
                                (loading || initialLoading) && !autoFetchReq &&
                                Array.from({ length: 10 }).map((_, i) => {
                                    return (
                                        <tr>
                                            <td><Skeleton /></td>
                                            <td><Skeleton /></td>
                                            <td><Skeleton /></td>
                                            <td><Skeleton /></td>
                                            <td><Skeleton /></td>
                                            <td><Skeleton /></td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                    {
                        !(loading || initialLoading) && error &&
                        <div className="py-3 d-flex justify-content-center align-items-center">
                            <button className="theme-btn theme-btn-sm btn-primary-outlined" onClick={nextPage}>Load More <i className='ms-2 fs-5 bx bx-refresh'></i></button>
                        </div>
                    }
                    {
                        !(loading || initialLoading) && campaignPermalinks.length === 0 &&
                        <div className="d-flex w-100 justify-content-center align-items-center my-5">
                            <div className="length-zero my-5">
                                <h3>Currently there is no posts in your list</h3>
                            </div>
                        </div>
                    }
                </InfiniteScroll>

            </div>
        </div>
    )
}

export default CampaignLinksStatus